import { Component, Input } from '@angular/core';
import { ApiMessage } from '@bhtp-client-api/base';
import { CoverageCartViewModel, CoverageCartTripDetailsViewModel, Mapper } from '@bhtp-client-web/component';

@Component({
    selector: 'agent-quote-sidebar',
    template: require('./agent-quote-sidebar.component.html')
})
export class AgentQuoteSidebarComponent {
    @Input() coverageCart: CoverageCartViewModel;
    @Input() tripDetail: CoverageCartTripDetailsViewModel;
    @Input() quoting: boolean;
    @Input() originalTotalCost: number;
    @Input() originalPremium: number;
    @Input() originalFees: number = 0;
    @Input() quoteErrors: ApiMessage = null;

    constructor() { }

    public get displayFees(): boolean {
        return this.coverageCart.package.fees > 0 || this.originalFees > 0;
    }

    public get departureDate(): string {
        return Mapper.fromParseFormatToDisplayFormat(this.tripDetail.departureDate);
    }

    public get returnDate(): string {
        return Mapper.fromParseFormatToDisplayFormat(this.tripDetail.returnDate);
    }

    public showDifference(): boolean {
        if (this.coverageCart) {
            return (typeof this.coverageCart.difference !== 'undefined' && this.coverageCart.difference !== undefined && this.coverageCart.difference !== null);
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/agent-quote-sidebar/agent-quote-sidebar.component.ts